const APP_PAGE_URL = '/app';
const APP_LINK = 'https://hhs0.app.link/new_app_link';

const generateAppleStoreUrl = (campaign) => `https://apps.apple.com/app/apple-store/id962532589?pt=117125988&ct=${campaign}&mt=8`;
const generateGooglePlayStoreUrl = (campaign) => `https://play.google.com/store/apps/details?id=com.wanderu.wanderu&utm_source=web&utm_campaign=${campaign}`;

export {
    APP_LINK,
    APP_PAGE_URL,
    generateAppleStoreUrl,
    generateGooglePlayStoreUrl,
};
